import { Countries } from 'typings'
import {
  CAPTURE_THREE,
  FIVE_FOUR_SET_NUMBER,
  NOT_NUMBER,
  SPACE,
  THREE_FOUR_SET_NUMBER,
} from './regex'

/**
 * Format postal code for each country.
 * Spec: https://frit.rickcloud.jp/wiki/display/ACPF/Postal+Code+Format
 * @param postalCode
 * @param country
 * @returns formatted postal code string
 */

export const formatPostalCode = (
  postalCode: string,
  country: string,
): string => {
  switch (country) {
    case Countries.CA:
      return postalCode
        .replace(SPACE, '')
        .replace(CAPTURE_THREE, '$1 ')
        .trim()
    case Countries.JP:
      return postalCode
        .replace(NOT_NUMBER, '')
        .replace(THREE_FOUR_SET_NUMBER, '〒$1-$2')
    case Countries.US:
      return postalCode
        .replace(NOT_NUMBER, '')
        .replace(FIVE_FOUR_SET_NUMBER, '$1-$2')
    default:
      return postalCode.replace(SPACE, '')
  }
}
